<template>
  <base-template current-page="OverpacksIndex">
    <router-view></router-view>
  </base-template>
</template>

<script>
import BaseTemplate from "../BaseTemplate";

export default {
  name: "OverpacksIndex",
  components: { BaseTemplate },
};
</script>
